import { useState } from 'react'
import { Button, InlineAlert, TextArea } from '../BaseComponents'
import CanonicalModal from '../BaseComponents/CanonicalModal/CanonicalModal'
import useApi from '../../hooks/useApi'
import { getApiErrorMessage, getCSRFToken } from '../../lib/utils'

type OrganisationUnlockRequestModalProps = {
	open: boolean
	companyId: string
	companyName: string
	onClose: () => void
}

function OrganisationUnlockRequestModal({
	open,
	companyId,
	companyName,
	onClose,
}: OrganisationUnlockRequestModalProps) {
	const api = useApi()
	const [reason, setReason] = useState('')
	const [busy, setBusy] = useState(false)
	const [sent, setSent] = useState(false)
	const [error, setError] = useState('')

	const onSend = async () => {
		setBusy(true)
		setError('')
		try {
			await api.post('organisations/request-unlock', {
				companyId,
				reason,
				_csrf: await getCSRFToken(),
			})
			setSent(true)
		} catch (err) {
			setError(getApiErrorMessage(err, 'Could not send your request. Please try again later.'))
		} finally {
			setBusy(false)
		}
	}

	return (
		<CanonicalModal
			open={open}
			onClose={onClose}
			title='Request unlock'
			subtitle={companyName}
			actions={
				sent ? (
					<Button type='Primary' text='Close' onClick={onClose} />
				) : (
					<>
						<Button
							type='Primary'
							text='Send request'
							disabled={busy || !reason.trim()}
							onClick={onSend}
							additionalClass='mr-5'
						/>
						<Button type='Outlined' text='Cancel' onClick={onClose} />
					</>
				)
			}
		>
			{sent ? (
				<p className='text-white mt-8'>Request sent. We will be in touch by email shortly.</p>
			) : (
				<div className='mt-8 text-white'>
					<p className='mb-4'>Tell us why you would like this organisation unlocked.</p>
					<TextArea
						label='Reason'
						name='reason'
						rows={4}
						maxLength={1000}
						value={reason}
						onChange={(e) => setReason(e.target.value)}
						disabled={busy}
					/>
					{error && (
						<InlineAlert type='error' className='mt-4'>
							{error}
						</InlineAlert>
					)}
				</div>
			)}
		</CanonicalModal>
	)
}

export default OrganisationUnlockRequestModal
